import { Link } from 'react-router-dom'
import { CheckIcon } from '@/shared/ui/icons/CheckIcon'
import type { OrgNewDraft } from '@/public/features/org/types'
import { CARD_MAX } from '@/public/features/org/constants/orgNew'
import { buttonStyles } from '@/shared/ui/Button'
import { SubmitResultScreen } from '@/shared/ui/SubmitResultScreen'
import { ROW_CLASS } from '@/shared/ui/buttonRow'

export function OrgDone() {
  return (
    <SubmitResultScreen
      icon={<CheckBadge />}
      title="기업 등록을 완료했어요."
      titleWeight="medium"
      description="해결카드가 1개 이상 있어야 시민 카드와 매칭됩니다."
      gap={60}
    />
  )
}
export function CheckBadge() {
  return (
    <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-[99px] bg-violet-500 text-white-50 [&>svg]:h-4 [&>svg]:w-4">
      <CheckIcon />
    </span>
  )
}
export function CardDone() {
  return (
    <SubmitResultScreen
      icon={<CheckBadge />}
      title="해결 카드 등록을 완료했어요."
      titleWeight="medium"
      gap={60}
    />
  )
}
export function DoneButtons({ draft, rowClass = ROW_CLASS }: { draft: OrgNewDraft; rowClass?: string }) {
  const count = `(${draft.cardCount}/${CARD_MAX})`

  if (draft.stage === 'org-done') {
    return (
      <div className={rowClass}>
        <button
          type="button"
          className={buttonStyles('lg', 'primary', 'ui-pressable min-w-0 flex-1 shrink-0 grow basis-0')}
          onClick={draft.startNextCard}
        >
          {`해결카드 만들기 ${count}`}
        </button>
      </div>
    )
  }

  return (
    <div className={rowClass}>
      <Link
        className={buttonStyles('lg', 'assistive', 'ui-pressable w-[90px] shrink-0 justify-center px-[22px] py-3 no-underline')}
        to="/"
      >
        홈으로
      </Link>
      <button
        type="button"
        className={buttonStyles('lg', 'primary', 'ui-pressable min-w-0 flex-1 shrink-0 grow basis-0')}
        disabled={!draft.canMakeMoreCards}
        onClick={draft.startNextCard}
      >
        {`해결 카드 만들기 ${count}`}
      </button>
    </div>
  )
}
